import React, { Component } from 'react';
import Notifications from './Notifications';
import ProjectList from '../projects/ProjectList';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';

class Dashboard extends Component {
  render() {
    // console.log(this.props);
    const { projects, auth, notifications, profile } = this.props;

    // this will redirect users to signin if they are NOT signed in
    if (!auth.uid) return <Redirect to='/signin' />

    return (
      <div className="dashboard container">
        <div className="row">
          <div className="col sm12 m12 grey-text">
            <h3 className="center-align">Welcome to your task dashboard, { profile.firstName }!</h3>
          </div>
        </div>
        <div className="row">
          <div className="col s12 m6">
            <ProjectList projects={ projects }/>
          </div>
          <div className="col s12 m5 offset-m1">
            <Notifications notifications={ notifications } />
          </div>
        </div>
      </div>
    )
  }
}

// this function takes the properties from the state object in the store,
// and maps them to the props for this component
// Then, we can pass these props down into the child functional components
const mapStateToProps = (state) => {
 
  return {
    projects: state.firestore.ordered.projects,
    auth: state.firebase.auth,
    notifications: state.firestore.ordered.notifications,
    profile: state.firebase.profile
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: 'projects', orderBy: ['createdAt','desc'] },
    { collection: 'notifications', limit: 3, orderBy: ['time','desc'] }
  ])
)(Dashboard)